import { SelfieState } from "../types";

const state: SelfieState = {
  turnDirection: "left",
};

export default state;
